module.exports = __webpack_public_path__ + "static/media/screenshot-reviews.3f341307.png";